import { ApolloClient, HttpLink, InMemoryCache, ApolloLink } from '@apollo/client'

export const createClient = async () => {
  const authLink = new ApolloLink((operation, forward) => {
    const { headers = {} } = operation.getContext()

    operation.setContext({
      headers: {
        ...headers,
      },
    })

    return forward(operation)
  })

  const cache = new InMemoryCache()

  const httpLink = new HttpLink({
    uri: process.env.GLADOS_URL,
  })

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
  })
}
